import { Modal } from 'react-bootstrap';


function MusicModal({setShow, setPlaying}) {



  return (
    <div className="modal">
        <div className="dialog">
            <center>
                <img src="/images/icon/volume-up-fill.svg" alt="Music Icon" style={{ width: '150px', height: '150px' }} />
            </center>
        
            <p>為了讓您有更好的體驗，建議您開啟音樂。</p>
            <div className='flex-container'>
            <button onClick={() => {setShow(false)}} className="music-button-no">否</button>

            <button className="music-button-yes" onClick={() => {setPlaying(true); setShow(false);}}>
                是
            </button>
            </div>
        </div>
    </div>
  );
}

export default MusicModal;